<template>
  <div class="order-detail-tips">
    <!-- 老数据 -->
    <div v-if="isOldVilocalSku">Free trial set </div>
    <!-- 新数据 -->
    <div v-if="!isOldVilocalSku && consignNum>0 && freeTrialNum>0">{{freeTrialNum}} item<span v-if="freeTrialNum>1">s</span> for free trial and {{consignNum}} item<span v-if="consignNum>1">s</span> with free returns.</div>
    <div v-if="!isOldVilocalSku && consignNum>0 && (freeTrialNum === null || freeTrialNum<=0)">{{consignNum}} item<span v-if="consignNum>1">s</span> with free returns.</div>
    <div v-if="!isOldVilocalSku && freeTrialNum>0 && (consignNum === null || consignNum<=0)">{{freeTrialNum}} item<span v-if="freeTrialNum>1">s</span> free trial.</div>
    <div v-if="!isOldVilocalSku && vilocalType===4">
      {{`${num} item for ${Number(discountTrialRate).toFixed(0)}% trial`}}
    </div>
  </div>
</template>

<script>
export default {
  props: {
    isOldVilocalSku: {
      type: Boolean,
      default: false
    },
    consignNum: {
      type: Number,
      default: null
    },
    freeTrialNum: {
      type: Number,
      default: null
    } ,
    vilocalType: {
      type: Number,
      default: null
    },
    num: {
      type: Number,
      default: null
    },
    discountTrialRate: {
      type: Number,
      default: null
    }
  }
}
</script>

<style lang="less" scoped>
.order-detail-tips{
  margin-top: 10px;
  div{
    font-size: 14px;
    font-family: Satoshi-Regular;
    color: #FF4812;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/components/vilocal-order-detail.vue